import React from 'react';

import styled from 'styled-components';

/* eslint-disable-next-line */
export interface FeatureAuthProps {}

const StyledFeatureAuth = styled.div`
    color: pink;
`;

export function FeatureAuth(props: FeatureAuthProps) {
    return (
        <StyledFeatureAuth>
            <h1>Welcome to feature-auth!</h1>
        </StyledFeatureAuth>
    );
}

export default FeatureAuth;
